export default "__VITE_ASSET__dhkRc_Ad__"